import React from 'react';

const Main = () => {
  return (
    <div className="px-12 pt-14 pb-14 max-w-6xl mx-auto">
      <div className="text-5xl font-thin text-white lg:text-6xl">
        <span>Welcome to Gutmicro.Net</span>
      </div>
      <div className="mt-10 font-thin text-white lg:text-lg">
        <p>
          GutMicroNet is an interactive visualization platform of human gut
          microbiome interaction networks. We included {'>'} 1900 gut microbiome
          species and generated 45 gut microbiome co-abundance networks from
          various geographical origins, gender, and diseases based on the data
          from the {' '}
          <a
            href="https://www.microbiomeatlas.org/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white font-medium"
          >
            Human Gut Microbiome Atlas
          </a>
          .
        </p>
        <span></span>
        <p className="pt-4">
          Users can visualize multiple species, adjust the statistical
          properties, and interact with the visualized networks to explore
          interactions with other species, modify the network, and download the
          network as a static image or text file that can be imported to other
          network analysis software or modules for more complex downstream
          analyses. We believe that GutMicroNet is a unique and powerful
          platform that will open multiple new paths and opportunities in
          disease- and microbiome-related research.
        </p>
        <span></span>
        <img
          src={process.env.PUBLIC_URL + '/welcome.png'}
          alt="welcome"
          loading="lazy"
          className="pt-4"
        />
      </div>
    </div>
  );
};

export default Main;
